import React, { useState } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import BackgroundSlider from "../BackGround/BackgroundSlider";
import "react-toastify/dist/ReactToastify.css";
import Logo from "../../images/Logo.png";
import "./Design.css";
import { useParams } from "react-router-dom";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function EnterPassword() {
  const [password, setPassword] = useState("");
  const [reEnterPassword, setReEnterPassword] = useState("");
  const [success, setSuccess] = useState(false); // Track if the password was successfully reset
  const {token} = useParams();
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password.length === 0) {
      toast.error("Please enter your password");
    } else if (reEnterPassword.length === 0) {
      toast.error("Please re-enter your password");
    } else if (password !== reEnterPassword) {
      toast.error("Passwords do not match");
    } else {
      try {
          const response = await axios.post(`${BACKEND_URL}/api/reset-password/${token}`, {
          newPassword: password,
        });

        if (response.status === 200) {
          toast.success(response.data.message);
          setSuccess(true); // Display success message
        }
      } catch (error) {
        console.error("Error resetting password:", error);
        if (error.response && error.response.data && error.response.data.message) {
          toast.error(error.response.data.message);
        } else {
          toast.error("Failed to reset password");
        }
      }
    }
  };

  return (
    <>
      <div className="header">
        <img src={Logo} alt="Fisko" className="Logo" />
      </div>

      <div className="EnterEmail-page">
        <BackgroundSlider />
        <div className="login-box">
          <main className="loginContainer">
            {success ? (
              <div className="successMessage">
                <h1 className="title">Password Reset Successfully</h1>
                <p className="subtitle">Your password has been updated. You can now log in with your new password.</p>
                <a href="/login">
                <button
                  style={{width:"75%"}}
                  className="SignInButton"
                >
                  Sign In
                </button>
                </a>
              </div>
            ) : (
              <>
                <header className="headerSection">
                  <h1 className="title">Set New Password</h1>
                  <h2 className="subtitle">Enter and confirm your new password</h2>
                </header>

                <form onSubmit={handleSubmit}>
                  <div className="formGroup">
                    <label htmlFor="password" className="inputLabel">
                      Password
                    </label>
                    <input
                      type="password"
                      id="password"
                      className="formInput"
                      placeholder="Enter your new password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                  </div>

                  <div className="formGroup">
                    <label htmlFor="reEnterPassword" className="inputLabel">
                      Re-enter Password
                    </label>
                    <input
                      type="password"
                      id="reEnterPassword"
                      className="formInput"
                      placeholder="Re-enter your new password"
                      value={reEnterPassword}
                      onChange={(e) => setReEnterPassword(e.target.value)}
                      required
                    />
                  </div>

                  <button type="submit" className="signUpButton">
                    Set Password
                  </button>
                </form>
              </>
            )}
          </main>
        </div>
      </div>

      {/* Toast container */}
      <ToastContainer />
    </>
  );
}
